import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { PaymentsApi } from '@shared/api/rest/payments';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface DeleteRequisitesType {
  loading: boolean;
  error: string | null;
  success: boolean | null;
  delete: (id: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDeleteRequisitesStore = create<DeleteRequisitesType>((set) => ({
  loading: false,
  error: null,
  success: null,

  delete: ApiUtils.wrapperApi(async (id, signal) => {
    try {
      set({ loading: true, error: null, success: null });
      await PaymentsApi.deleteRequisites(id, signal);
      set({ loading: false, success: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null, success: null }),
}));
